export default __webpack_public_path__ + "static/media/lines-behind.2870011f.png";